import { Skeleton as AntSkeleton } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { CpSectionWrapper } from 'components/organisms/customer-portal/widgets/common';
import {
  CpLoadingDesc,
  CpLoadingProps,
  CpLoadingTitle,
  CpWidgetLoadingSkeletonWrapper,
} from '../common';

const Wrapper = styled(CpWidgetLoadingSkeletonWrapper)`
  display: flex;
  align-items: center;
  justify-content: start;
  gap: var(--cp-spacing-06);
  flex-wrap: wrap;
  width: 100%;
  background: transparent;
  height: auto;
  margin-top: var(--cp-spacing-06);

  @media (max-width: 480px) {
    gap: var(--cp-spacing-05);
    flex-direction: column;
    margin-top: var(--cp-spacing-04);
  }
`;

const CardSkeleton = styled(AntSkeleton.Button)`
  .ant-skeleton,
  .ant-skeleton-button,
  &.ant-skeleton,
  &.ant-skeleton-button,
  & {
    max-width: 100% !important;
    width: 340px !important;
    height: 160px !important;
  }
`;

const Skeleton: React.FC = () => {
  return <CardSkeleton active shape="square" />;
};

export const CpCardsGridLoading: React.FC = () => {
  return (
    <Wrapper>
      <Skeleton />
      <Skeleton />
      <Skeleton />
    </Wrapper>
  );
};

export const CpSummaryInformationLoadingSkeleton: React.FC<CpLoadingProps> = ({
  styles,
  input,
}) => {
  return (
    <CpSectionWrapper
      background={styles?.background as string}
      paddingY={styles?.paddingY as number | undefined}
      className="!cp-max-w-none"
    >
      <CpLoadingTitle active />
      <CpLoadingDesc active />

      <Wrapper>
        {((input?.fieldNames ?? [1, 2, 3]) as string[])?.map?.((e) => (
          <Skeleton key={e} />
        ))}
      </Wrapper>
    </CpSectionWrapper>
  );
};
